
import React from 'react'
import { Animated } from 'react-web-animation'

export default class RoomXS extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 1051,
      originalHeight: 944
    }
    this.state = {
      ...this.state,
      width: parseFloat(props.width),
      height: this.state.originalHeight / (this.state.originalWidth / parseFloat(props.width)),
      ratio: this.state.originalWidth / parseFloat(props.width)
    }
  }
  render() {
    return (
      <div>
        <svg width={this.state.width} height={this.state.height} viewBox={`0 0 ${this.state.originalWidth} ${this.state.originalHeight}`}>
          <defs>
            <polygon id="path-1" points="43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523"/>
            <polygon id="path-2" points="389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662"/>
            <polygon id="path-3" points="216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572"/>
            <polygon id="path-4" points="130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547"/>
            <polygon id="path-5" points="302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596"/>
            <polygon id="path-6" points="43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523"/>
            <polygon id="path-7" points="389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662"/>
            <polygon id="path-8" points="216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572"/>
            <polygon id="path-9" points="130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547"/>
            <polygon id="path-10" points="302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596"/>
            <polygon id="path-11" points="43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523"/>
            <polygon id="path-12" points="389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662"/>
            <polygon id="path-13" points="216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572"/>
            <polygon id="path-14" points="130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547"/>
            <polygon id="path-15" points="302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596"/>
            <polygon id="path-16" points="43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523"/>
            <polygon id="path-17" points="389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662"/>
            <polygon id="path-18" points="216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572"/>
            <polygon id="path-19" points="130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547"/>
            <polygon id="path-20" points="302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596"/>
            <polygon id="path-21" points="43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523"/>
            <polygon id="path-22" points="389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662"/>
            <polygon id="path-23" points="216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572"/>
            <polygon id="path-24" points="130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547"/>
            <polygon id="path-25" points="302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596"/>
          </defs>
          <g id="Packages/XS" fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
            <polygon id="Rectangle-8" fill="#DFDFDF" points="140.714328 184.071615 669.932359 185.746854 477.171295 460.364297 -52.0467354 458.689058" transform="translate(308.942812, 322.217956) rotate(-35.000000) translate(-308.942812, -322.217956) "/>
            <polygon id="Rectangle-8" fill="#929292" points="571.498179 185.411826 1099.89647 185.742288 907.926659 460.05991 380.736532 459.747136" transform="translate(740.316503, 322.735868) scale(-1, 1) rotate(-35.000000) translate(-740.316503, -322.735868) "/>
            <g id="Boden/5x5" transform="translate(-338.000000, 311.000000)">
              <g id="10m" transform="translate(430.473868, 241.756098)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(87.218049, 87.218049) rotate(45.000000) translate(-87.218049, -87.218049) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523"/>
                  <path d="M44.3944365,44.3944365 L26.3038391,148.132259 L130.041661,130.041661 L148.132259,26.3038391 L44.3944365,44.3944365 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(432.583903, 328.974147) rotate(45.000000) translate(-432.583903, -328.974147) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662"/>
                  <path d="M389.76029,286.150534 L371.669693,389.888356 L475.407515,371.797759 L493.498112,268.059937 L389.76029,286.150534 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(259.900976, 208.096098) rotate(45.000000) translate(-259.900976, -208.096098) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572"/>
                  <path d="M217.077363,165.272485 L198.986766,269.010308 L302.724588,250.91971 L320.815186,147.181888 L217.077363,165.272485 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(173.559512, 147.657073) rotate(45.000000) translate(-173.559512, -147.657073) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547"/>
                  <path d="M130.7359,104.833461 L112.645303,208.571283 L216.383125,190.480686 L234.473722,86.7428635 L130.7359,104.833461 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(346.242439, 268.535122) rotate(45.000000) translate(-346.242439, -268.535122) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596"/>
                  <path d="M303.418827,225.71151 L285.328229,329.449332 L389.066052,311.358735 L407.156649,207.620912 L303.418827,225.71151 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
              </g>
              <g id="10m" transform="translate(516.815331, 181.317073)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(87.218049, 87.218049) rotate(45.000000) translate(-87.218049, -87.218049) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523"/>
                  <path d="M44.3944365,44.3944365 L26.3038391,148.132259 L130.041661,130.041661 L148.132259,26.3038391 L44.3944365,44.3944365 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(432.583903, 328.974147) rotate(45.000000) translate(-432.583903, -328.974147) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662"/>
                  <path d="M389.76029,286.150534 L371.669693,389.888356 L475.407515,371.797759 L493.498112,268.059937 L389.76029,286.150534 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(259.900976, 208.096098) rotate(45.000000) translate(-259.900976, -208.096098) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572"/>
                  <path d="M217.077363,165.272485 L198.986766,269.010308 L302.724588,250.91971 L320.815186,147.181888 L217.077363,165.272485 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(173.559512, 147.657073) rotate(45.000000) translate(-173.559512, -147.657073) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547"/>
                  <path d="M130.7359,104.833461 L112.645303,208.571283 L216.383125,190.480686 L234.473722,86.7428635 L130.7359,104.833461 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(346.242439, 268.535122) rotate(45.000000) translate(-346.242439, -268.535122) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596"/>
                  <path d="M303.418827,225.71151 L285.328229,329.449332 L389.066052,311.358735 L407.156649,207.620912 L303.418827,225.71151 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
              </g>
              <g id="10m" transform="translate(603.156794, 120.878049)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(87.218049, 87.218049) rotate(45.000000) translate(-87.218049, -87.218049) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523"/>
                  <path d="M44.3944365,44.3944365 L26.3038391,148.132259 L130.041661,130.041661 L148.132259,26.3038391 L44.3944365,44.3944365 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(432.583903, 328.974147) rotate(45.000000) translate(-432.583903, -328.974147) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662"/>
                  <path d="M389.76029,286.150534 L371.669693,389.888356 L475.407515,371.797759 L493.498112,268.059937 L389.76029,286.150534 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(259.900976, 208.096098) rotate(45.000000) translate(-259.900976, -208.096098) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572"/>
                  <path d="M217.077363,165.272485 L198.986766,269.010308 L302.724588,250.91971 L320.815186,147.181888 L217.077363,165.272485 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(173.559512, 147.657073) rotate(45.000000) translate(-173.559512, -147.657073) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547"/>
                  <path d="M130.7359,104.833461 L112.645303,208.571283 L216.383125,190.480686 L234.473722,86.7428635 L130.7359,104.833461 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(346.242439, 268.535122) rotate(45.000000) translate(-346.242439, -268.535122) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596"/>
                  <path d="M303.418827,225.71151 L285.328229,329.449332 L389.066052,311.358735 L407.156649,207.620912 L303.418827,225.71151 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
              </g>
              <g id="10m" transform="translate(688.264808, 60.439024)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(87.218049, 87.218049) rotate(45.000000) translate(-87.218049, -87.218049) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523"/>
                  <path d="M44.3944365,44.3944365 L26.3038391,148.132259 L130.041661,130.041661 L148.132259,26.3038391 L44.3944365,44.3944365 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(432.583903, 328.974147) rotate(45.000000) translate(-432.583903, -328.974147) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662"/>
                  <path d="M389.76029,286.150534 L371.669693,389.888356 L475.407515,371.797759 L493.498112,268.059937 L389.76029,286.150534 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(259.900976, 208.096098) rotate(45.000000) translate(-259.900976, -208.096098) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572"/>
                  <path d="M217.077363,165.272485 L198.986766,269.010308 L302.724588,250.91971 L320.815186,147.181888 L217.077363,165.272485 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(173.559512, 147.657073) rotate(45.000000) translate(-173.559512, -147.657073) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547"/>
                  <path d="M130.7359,104.833461 L112.645303,208.571283 L216.383125,190.480686 L234.473722,86.7428635 L130.7359,104.833461 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(346.242439, 268.535122) rotate(45.000000) translate(-346.242439, -268.535122) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596"/>
                  <path d="M303.418827,225.71151 L285.328229,329.449332 L389.066052,311.358735 L407.156649,207.620912 L303.418827,225.71151 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
              </g>
              <g id="10m" transform="translate(774.606272, 0.000000)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(87.218049, 87.218049) rotate(45.000000) translate(-87.218049, -87.218049) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="43.8613654 43.8613654 148.890523 25.5455751 130.574733 130.574733 25.5455751 148.890523"/>
                  <path d="M44.3944365,44.3944365 L26.3038391,148.132259 L130.041661,130.041661 L148.132259,26.3038391 L44.3944365,44.3944365 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(432.583903, 328.974147) rotate(45.000000) translate(-432.583903, -328.974147) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="389.227219 285.617463 494.256376 267.301673 475.940586 372.33083 370.911429 390.64662"/>
                  <path d="M389.76029,286.150534 L371.669693,389.888356 L475.407515,371.797759 L493.498112,268.059937 L389.76029,286.150534 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(259.900976, 208.096098) rotate(45.000000) translate(-259.900976, -208.096098) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="216.544292 164.739414 321.57345 146.423624 303.257659 251.452781 198.228502 269.768572"/>
                  <path d="M217.077363,165.272485 L198.986766,269.010308 L302.724588,250.91971 L320.815186,147.181888 L217.077363,165.272485 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(173.559512, 147.657073) rotate(45.000000) translate(-173.559512, -147.657073) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="130.202829 104.30039 235.231986 85.9845995 216.916196 191.013757 111.887039 209.329547"/>
                  <path d="M130.7359,104.833461 L112.645303,208.571283 L216.383125,190.480686 L234.473722,86.7428635 L130.7359,104.833461 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(346.242439, 268.535122) rotate(45.000000) translate(-346.242439, -268.535122) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="302.885756 225.178439 407.914913 206.862648 389.599123 311.891806 284.569965 330.207596"/>
                  <path d="M303.418827,225.71151 L285.328229,329.449332 L389.066052,311.358735 L407.156649,207.620912 L303.418827,225.71151 Z" stroke="#979797" strokeWidth="1.23344948"/>
                </g>
              </g>
            </g>
          </g>
        </svg>
        <Desk ratio={ this.state.ratio } />
        <Pretreat ratio={ this.state.ratio } />
        <Press ratio={ this.state.ratio } />
        <Gtx ratio={ this.state.ratio } />
        <Senddesk ratio={ this.state.ratio } />
      </div>
    )
  }
}

class Desk extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 343,
      originalHeight: 245,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 456 / this.state.ratio, left: 181 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/desk.png")} />
    )
  }
}

class Press extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 262,
      originalHeight: 256,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 325 / this.state.ratio, left: 351 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/press.png")} />
    )
  }
}

class Pretreat extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 262,
      originalHeight: 245,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 275 / this.state.ratio, left: 439 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/pretreat.png")} />
    )
  }
}

class Gtx extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 434,
      originalHeight: 309,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 455 / this.state.ratio, left: 436 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/gtx.png")} />
    )
  }
}

class Senddesk extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 349,
      originalHeight: 276,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 665 / this.state.ratio, left: 350 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/senddesk.png")} />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/room/rooms/XS.js